import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    brand: {
      50: '#ecfeff',
      100: '#cffafe',
      200: '#a5f3fc',
      300: '#67e8f9',
      400: '#22d3ee',
      500: '#06b6d4',
      600: '#0891b2',
      700: '#0e7490',
      800: '#155e75',
      900: '#164e63',
    },
    ocean: {
      50: '#eff6ff',
      100: '#dbeafe',
      500: '#3b82f6',
      800: '#1e3a8a',
      900: '#05112f',
      950: '#020718',
    },
  },
  styles: {
    global: {
      body: {
        bg: '#030a1c',
        color: '#e0f2fe',
        backgroundImage: 'radial-gradient(ellipse 80% 60% at 50% -20%, rgba(6, 182, 212, 0.25), transparent)',
        minHeight: '100vh',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: '14px',
        fontWeight: 'semibold',
        backdropFilter: 'blur(8px)',
        transition: 'all 0.25s ease',
      },
      variants: {
        solid: {
          bg: 'linear-gradient(135deg, rgba(6, 182, 212, 0.85) 0%, rgba(37, 99, 235, 0.85) 100%)',
          color: 'white',
          border: '1px solid rgba(103, 232, 249, 0.35)',
          boxShadow: '0 8px 24px rgba(6, 182, 212, 0.3), inset 0 1px 2px rgba(255, 255, 255, 0.35)',
          _hover: {
            bg: 'linear-gradient(135deg, rgba(6, 182, 212, 1) 0%, rgba(37, 99, 235, 1) 100%)',
            boxShadow: '0 12px 30px rgba(6, 182, 212, 0.5), inset 0 1px 2px rgba(255, 255, 255, 0.5)',
            transform: 'translateY(-2px)',
          },
          _active: {
            transform: 'translateY(0)',
          },
        },
        ghost: {
          color: '#67e8f9',
          _hover: {
            bg: 'rgba(6, 182, 212, 0.12)',
            color: '#a5f3fc',
          },
        },
      },
    },
    Modal: {
      baseStyle: {
        dialog: {
          borderRadius: '20px',
          bg: 'rgba(4, 18, 48, 0.82)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(56, 189, 248, 0.3)',
          boxShadow: '0 24px 70px rgba(0, 3, 15, 0.8), inset 0 1px 2px rgba(255, 255, 255, 0.15)',
        },
        header: {
          color: '#f0f9ff',
          borderBottom: '1px solid rgba(56, 189, 248, 0.15)',
        },
        body: {
          color: '#bae6fd',
        },
        footer: {
          borderTop: '1px solid rgba(56, 189, 248, 0.15)',
        },
        overlay: {
          backdropFilter: 'blur(10px)',
          bg: 'rgba(2, 7, 24, 0.75)',
        },
      },
    },
    Drawer: {
      baseStyle: {
        dialog: {
          bg: 'linear-gradient(180deg, rgba(7, 21, 56, 0.94) 0%, rgba(3, 11, 30, 0.98) 100%)',
          backdropFilter: 'blur(16px)',
          borderRight: '1px solid rgba(56, 189, 248, 0.25)',
        },
      },
    },
    Toast: {
      baseStyle: {
        borderRadius: '16px',
        bg: 'rgba(4, 21, 52, 0.85)',
        backdropFilter: 'blur(14px)',
        color: '#f0f9ff',
        border: '1px solid rgba(34, 211, 238, 0.35)',
        boxShadow: '0 12px 30px rgba(0, 0, 0, 0.5)',
      },
    },
  },
});

export default theme;